import { Link } from "react-router-dom";

/**
 * SmartLink — renders the right anchor for any admin-provided link:
 *  - http(s):// URLs        → <a target="_blank" rel="noopener noreferrer">
 *  - mailto: / tel:         → plain <a> (no target)
 *  - protocol-less external → prefixed with https:// + new tab (catches "wa.me/40...", "www.example.com")
 *  - everything else        → react-router <Link> (internal navigation, no reload)
 */

const ABSOLUTE_RE = /^https?:\/\//i;
const PROTOCOL_RE = /^(mailto:|tel:)/i;
const BARE_EXTERNAL_RE = /^(www\.|[a-z0-9-]+(\.[a-z0-9-]+)+(\/|\?|$))/i;

export function normalizeHref(to) {
  const raw = typeof to === "string" ? to.trim() : "";
  if (ABSOLUTE_RE.test(raw)) {
    return { external: true, href: raw, target: "_blank", rel: "noopener noreferrer" };
  }
  if (PROTOCOL_RE.test(raw)) {
    return { external: true, href: raw };
  }
  if (BARE_EXTERNAL_RE.test(raw)) {
    return { external: true, href: `https://${raw}`, target: "_blank", rel: "noopener noreferrer" };
  }
  return { external: false, href: raw || "/" };
}

export default function SmartLink({ to, children, ...rest }) {
  const n = normalizeHref(to);
  if (n.external) {
    return (
      <a href={n.href} target={n.target} rel={n.rel} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={n.href} {...rest}>
      {children}
    </Link>
  );
}
